import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import i18next from "i18next";
import i18nextXhr from "i18next-xhr-backend";

import { i18nextOptions } from "services/i18n/i18nextOptions.js";
import store from "services/localStore/store";

export class AppApplicationInsights {
    static current;
    static reactPlugin;
}

const appInit = (language, initFinishedCallback) => {
    // Application Insights init
    if (process.env.REACT_APP_AI_KEY) {
        const reactPlugin = new ReactPlugin();
        AppApplicationInsights.reactPlugin = reactPlugin;

        AppApplicationInsights.current = new ApplicationInsights({
            config: {
                instrumentationKey: process.env.REACT_APP_AI_KEY,
                extensions: [reactPlugin],
                extensionConfig: {
                    // Do NOT pass history here to avoid errors with React Router v6
                    [reactPlugin.identifier]: { history: null },
                },
            },
        });
        AppApplicationInsights.current.loadAppInsights();

        const state = store.getState();
        if (state.userProfile) {
            AppApplicationInsights.current.setAuthenticatedUserContext(state.userProfile.userName);
        }
    } else {
        console.log("Skipping ApplicationInsights - No key was provided");
    }

    // i18next initialization
    const options = i18nextOptions;
    options.lng = language;
    options.fallbackLng = language; // Avoid loading a second default language
    options.react = { wait: true };

    i18next.use(i18nextXhr).init(options, () => {
        initFinishedCallback();
    });
};

export default appInit;
